//Imports node_modules
import React, { useState, useContext } from "react";


//Import Data
import { globalFunctions } from "./GlobalFunctions";




//Variaveis inicias
const initialStateForms = {
    formFildsByType:
        [
            {
                nameForm: 'nameRegist',
                formStyle: 'success',
                titleForm: 'Insira o nome de dispositivo:',
                iconFrom: '',
                description: 'Este nome será usado pelo seu administrador para identificar este dispositivo.',
                fields: [
                    { name: 'Nome do dispositivo:', size: 12, type: 'text', placeholder: 'Insira o nome desejado...', value: '' },
                ],
                noback: true,
            },
        ],
}

export const globalForms = React.createContext(initialStateForms)

const GlobalForms = params => {
    const [stateForms, setStateForms] = useState(initialStateForms)

    const {
        SaveDispName,
    } = useContext(globalFunctions);

    function updateState(key, value) {
        setStateForms({
            ...stateForms,
            [key]: value
        })
    }

    function onNextClicked(formName, fields) {
        //No futuro tentar evitar isto
        switch (formName) {
            case 'nameRegist':
                SaveDispName(fields)
                break;

            default:
                break;
        }
    }

    function onChangeField(nameForm, fiedlName, fieldValue) {


        let formFieldArray = [];

        Object.keys(stateForms.formFildsByType).forEach(function (form, indexForm) {
            formFieldArray.push(stateForms.formFildsByType[indexForm])
        });

        Object.keys(formFieldArray).forEach(function (form, indexForm) {
            if (formFieldArray[indexForm].nameForm === nameForm) {
                Object.keys(formFieldArray[indexForm].fields).forEach(function (field, indexField) {
                    if (formFieldArray[indexForm].fields[indexField].name === fiedlName) {
                        formFieldArray[indexForm].fields[indexField].value = fieldValue;
                    }
                });
            }
        });

        setStateForms((prevState) => ({ ...prevState, formFildsByType: formFieldArray }));
    }

    const resetStateForms = () => {

        //Encontrar uma forma melhor de dar reset
        setStateForms((prevState) => ({
            ...prevState, formFildsByType:

                [
                    {
                        nameForm: 'nameRegist',
                        formStyle: 'success',
                        titleForm: 'Insira o nome de dispositivo:',
                        iconFrom: '',
                        description: 'Este nome será usado pelo seu administrador para identificar este dispositivo.',
                        fields: [
                            { name: 'Nome do dispositivo:', size: 12, type: 'text', placeholder: 'Insira o nome desejado...', value: '' },
                        ],
                    },
                ],
        }));

    };


    return (
        <globalForms.Provider value={{

            //Variavels
            formFildsByType: stateForms.formFildsByType,


            //---Funções
            //t = text, n = number, a = object/array b= boolean, d= date
            //Update States

            //Set variables
            OnChangeField: (nameForm, fiedlName, fieldValue) => onChangeField(nameForm, fiedlName, fieldValue),
            UpdateState: _ => updateState(),
            OnNextClicked: (formName, fields) => onNextClicked(formName, fields),

            //Reset Values
            ResetStateForms: (key, value) => resetStateForms(key, value),

            //---Fim Funções
        }}>
            {params.children}
        </globalForms.Provider>
    )
}

export default GlobalForms